import React from 'react';

import type { IntlShape } from 'react-intl';

import type {
	QuickInsertActionInsert,
	QuickInsertItem,
} from '@atlaskit/editor-common/provider-factory';
import type { EditorState } from '@atlaskit/editor-prosemirror/state';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';
import RovoIcon from '@atlassian/generative-ai-modal/assets/RovoIcon';

import { createOpenAIModalCommand } from '../../../../pm-plugins/decoration/actions';
import type { AIGlobalOptIn } from '../../../../types/types';
import { getTranslatedItemTitle } from '../config-items';
import type { EditorPluginAIConfigItem } from '../config-items';

export function mapConfigItemsToQuickInsertItems({
	configItems,
	formatMessage,
	aiGlobalOptIn,
	editorView,
	locale,
}: {
	aiGlobalOptIn: AIGlobalOptIn;
	configItems: EditorPluginAIConfigItem[];
	editorView: EditorView;
	formatMessage: IntlShape['formatMessage'];
	locale: string;
}): QuickInsertItem[] {
	const aiPriorities = 9000;

	const dispatch = editorView.dispatch;

	return configItems.map((configItem) => {
		const title = getTranslatedItemTitle(configItem, formatMessage);
		return {
			priority: configItem.quickInsertPriority ?? aiPriorities,
			categories: ['AI'],
			title,
			description: formatMessage(configItem.description || configItem.title),
			keywords: ['ai', 'generate', 'rovo', title],
			icon: () => {
				return configItem.icon ? (
					configItem.icon({ formatMessage })
				) : (
					<RovoIcon label="" size="small" />
				);
			},
			action: (insert: QuickInsertActionInsert, editorState: EditorState) => {
				// We set the openAIModalCommand to run on the next tick -- as it then
				// performs additional transactions to update the document

				requestAnimationFrame(() => {
					const openAIModalCommand = createOpenAIModalCommand({
						state: editorView.state,
						configItem,
						lastTriggeredFrom: 'quickInsert',
						aiGlobalOptIn,
						locale,
					});

					openAIModalCommand(editorView.state, dispatch);
				});

				// Insert empty string to remove the typeahead raw text
				// close the quick insert immediately
				const transaction = insert('');
				return transaction;
			},
			isDisabledOffline: true,
		};
	});
}
